// For small size
const wallStructure1ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4116.webp");
const wallStructure2ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4117.webp");
const wallStructure3ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4118.webp");
const wallStructure4ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4119.webp");
const wallStructure5ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4120.webp");
const wallStructure6ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4121.webp");
const wallStructure7ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4122.webp");
const wallStructure8ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4123.webp");
const wallStructure9ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4124.webp");
const wallStructure10ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4125.webp");
const wallStructure11ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4126.webp");
const wallStructure12ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4127.webp");
const wallStructure13ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4128.webp");
const wallStructure14ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4129.webp");
const wallStructure15ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4130.webp");
const wallStructure16ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4131.webp");
const wallStructure17ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4132.webp");
const wallStructure18ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4133.webp");
const wallStructure19ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4134.webp");
const wallStructure20ImageSm = require("../../../assets/images/products/subproducts/wall-structure-smallSize/frame_4135.webp");

const wallStructure1Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4096.webp");
const wallStructure2Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4097.webp");
const wallStructure3Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4098.webp");
const wallStructure4Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4099.webp");
const wallStructure5Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4100.webp");
const wallStructure6Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4101.webp");
const wallStructure7Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4102.webp");
const wallStructure8Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4103.webp");
const wallStructure9Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4104.webp");
const wallStructure10Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4105.webp");
const wallStructure11Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4106.webp");
const wallStructure12Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4107.webp");
const wallStructure13Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4108.webp");
const wallStructure14Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4109.webp");
const wallStructure15Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4110.webp");
const wallStructure16Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4111.webp");
const wallStructure17Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4112.webp");
const wallStructure18Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4113.webp");
const wallStructure19Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4114.webp");
const wallStructure20Image = require("../../../assets/images/products/subproducts/wall-structure-slider/frame_4115.webp");

export const ProductsGalleryArray = [
  {
    id: 1,
    imageBanner: wallStructure1Image,
    imageSlider: wallStructure1ImageSm,
  },
  {
    id: 2,
    imageBanner: wallStructure2Image,
    imageSlider: wallStructure2ImageSm,
  },
  {
    id: 3,
    imageBanner: wallStructure3Image,
    imageSlider: wallStructure3ImageSm,
  },
  {
    id: 4,
    imageBanner: wallStructure4Image,
    imageSlider: wallStructure4ImageSm,
  },
  {
    id: 5,
    imageBanner: wallStructure5Image,
    imageSlider: wallStructure5ImageSm,
  },
  {
    id: 6,
    imageBanner: wallStructure6Image,
    imageSlider: wallStructure6ImageSm,
  },
  {
    id: 7,
    imageBanner: wallStructure7Image,
    imageSlider: wallStructure7ImageSm,
  },
  {
    id: 8,
    imageBanner: wallStructure8Image,
    imageSlider: wallStructure8ImageSm,
  },
  {
    id: 9,
    imageBanner: wallStructure9Image,
    imageSlider: wallStructure9ImageSm,
  },
  {
    id: 10,
    imageBanner: wallStructure10Image,
    imageSlider: wallStructure10ImageSm,
  },
  {
    id: 11,
    imageBanner: wallStructure11Image,
    imageSlider: wallStructure11ImageSm,
  },
  {
    id: 12,
    imageBanner: wallStructure12Image,
    imageSlider: wallStructure12ImageSm,
  },
  {
    id: 13,
    imageBanner: wallStructure13Image,
    imageSlider: wallStructure13ImageSm,
  },
  {
    id: 14,
    imageBanner: wallStructure14Image,
    imageSlider: wallStructure14ImageSm,
  },
  {
    id: 15,
    imageBanner: wallStructure15Image,
    imageSlider: wallStructure15ImageSm,
  },
  {
    id: 16,
    imageBanner: wallStructure16Image,
    imageSlider: wallStructure16ImageSm,
  },
  {
    id: 17,
    imageBanner: wallStructure17Image,
    imageSlider: wallStructure17ImageSm,
  },
  {
    id: 18,
    imageBanner: wallStructure18Image,
    imageSlider: wallStructure18ImageSm,
  },
  {
    id: 19,
    imageBanner: wallStructure19Image,
    imageSlider: wallStructure19ImageSm,
  },
  {
    id: 20,
    imageBanner: wallStructure20Image,
    imageSlider: wallStructure20ImageSm,
  },
];
